import { FC } from 'react';

import { Outage } from '@/apis/outages/types/outagesApi';
import { Stack } from '@data-products-and-ai/react-components';
import { OutageCard } from '@/pages/Outages/components';

interface OutagesListProps {
  outages: Outage[];
}

export const OutagesList: FC<OutagesListProps> = ({ outages }) => {
  return (
    <Stack verticalAlign="top" gap={16}>
      {outages.map((outage) => (
        <OutageCard key={outage.outageId} outage={outage} />
      ))}
    </Stack>
  );
};
